import { BookingDetailsModalLoader } from '../BookingDetailsModalLoader';
import { BookingDetailsEdit } from './BookingDetailsEdit';

export function renderBookingDetailsEditModal() {
  return (
    <BookingDetailsModalLoader
      className={'t_booking_details_edit'}
      getAriaLabel={bookingNo => `Edit booking ${bookingNo}`}
      render={props => <BookingDetailsEdit {...props} />}
    />
  );
}
